// Read one cookie's value from document.cookie (URI-decoded), or undefined if absent.
export const readCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
};
